const initialState = {
	pageTitle: '',
	isLoading: 1,
	hasError: 0,
	error: ''
}

// ===================================
//	SEPERATED EXAMPLE
// ===================================
// export function siteInfoIsLoading(state = {}, action){
// 	switch (action.type){
// 		case 'SITE_INFO_IS_LOADING':
// 			return {
// 				...state,
// 				isLoading: 1
// 			}

// 		default:
// 			return state
// 	}
// }

export default (state = initialState, action) => {
	switch (action.type){

		// SITE INFO
		case 'SITE_INFO_IS_LOADING':
			return {
				...state,
				isLoading: 1
			}
		case 'SITE_INFO_HAS_ERROR':
			return {
				...state,
				isLoading: 0,
				hasError: 1,
				error: action.err
			}
		case 'SITE_INFO_SUCCESS':
			return {
				...state,
				...action.data.data,
				isLoading: 0
			}
		
		// MISC
		case 'GET_TRANSLATIONS_SUCCESS':
			return {
				...state,
				translations: {
					...action.translations
				}
			}
		
		case 'SET_PAGE_TITLE':
			return {
				...state,
				pageTitle: action.title
			}
		
		case 'GET_NOTICES_SUCCESS':
			return {
				...state,
				notice: action.notice
			}
		
		case 'GET_PROMOS_SUCCESS':
			if (Array.isArray(action.promos)){
				action.promos = action.promos.reduce(function (acc, cur, i) {
					// console.log(acc, cur, i)
					acc[i] = cur
					return acc
				}, {})
			}
			
			return {
				...state,
				promos: action.promos
			}
			
		// FREE SHIPPING
		case 'FREE_SHIPPING_IS_LOADING':
			return {
				...state,
				shipping: {},
				shippingIsLoading: 1,
				hasShippingError: 0,
				shippingError: ''
			}
		case 'FREE_SHIPPING_HAS_ERROR':
			return {
				...state,
				shippingIsLoading: 0,
				hasShippingError: 1,
				shippingError: action.err
			}
		case 'FREE_SHIPPING_SUCCESS':
			return {
				...state,
				shipping: {
					...action.data
				},
				shippingIsLoading: 0
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/siteInfo.js